import React, { useRef, useState, useEffect } from "react";
import i18n from "i18next";
import { IProduktDto } from "../../Models/IProdukt";
import { IUserProduct } from "../../Models/IUserProduct";
import { IProductDocuments } from "../../Models/UserProductDocuments";
import ProductDocumentColumns from "./ProductDocumentColumns";
import ProductDocumentsList from "./ProductDocumentsList";

interface IProductDocumentsProps {
  product: IProduktDto;
  userProduct?: IUserProduct;
  dokumente: IProductDocuments | undefined;
  onRefresh(): void;
}

function ProductDocuments(props: IProductDocumentsProps) {
  const productDocumentColumns = ProductDocumentColumns({
    onRefresh: () => {
      props.onRefresh();
    },
    allDocuments: props.dokumente?.auftragsDokumente,
  });

  return (
    <div>
      {productDocumentColumns.changeDeleteExecuteDialog()}
      {productDocumentColumns.deleteExecuteDialog()}
      {productDocumentColumns.deleteUserDocExecuteDialog()}

      <div style={{ marginTop: 20 }}>
        {/* Auftrag Dokumente */}
        {props.dokumente?.auftragsDokumente && (
          <ProductDocumentsList
            items={props.dokumente?.auftragsDokumente}
            columns={productDocumentColumns.getColumns("Auftrag")}
            title={i18n.t("auftragDokumente")}
          />
        )}

        {/* Exemplar Dokumente */}
        {props.dokumente?.exemplarDokumente && (
          <ProductDocumentsList
            items={props.dokumente?.exemplarDokumente}
            columns={productDocumentColumns.getColumns("Exemplar")}
            title={i18n.t("exemplarDokumente")}
          />
        )}

        {/* Artikel Dokumente */}
        {props.dokumente?.artikelDokumente && (
          <ProductDocumentsList
            items={props.dokumente?.artikelDokumente}
            columns={productDocumentColumns.getColumns("Artikel")}
            title={i18n.t("artikelDokumente")}
          />
        )}

        {/* User Dokumente */}
        {props.userProduct && props.dokumente?.userDokumente && (
          <ProductDocumentsList
            items={props.dokumente?.userDokumente}
            columns={productDocumentColumns.getColumns("User")}
            title={i18n.t("userDokumente")}
          />
        )}
      </div>
    </div>
  );
}

export default ProductDocuments;
